const SVG = 'http://www.w3.org/2000/svg';
const EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)';

function svgEl(name, attrs) {
  const el = document.createElementNS(SVG, name);
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
  return el;
}

function spark(layer, x, y, color, big) {
  const size = big ? 96 : 64;
  const half = size / 2;
  const svg = svgEl('svg', { width: size, height: size, viewBox: `0 0 ${size} ${size}` });
  svg.style.cssText = `position:absolute;left:${x - half}px;top:${y - half}px;overflow:visible`;
  layer.appendChild(svg);

  const rings = big ? [0, 110] : [0];
  rings.forEach((delay, i) => {
    const ring = svgEl('circle', {
      cx: half,
      cy: half,
      r: big ? 20 : 15,
      fill: 'none',
      stroke: color,
      'stroke-width': i ? 1 : 1.5,
    });
    ring.style.transformOrigin = 'center';
    ring.style.transformBox = 'fill-box';
    svg.appendChild(ring);
    ring.animate(
      [
        { transform: 'scale(0.35)', opacity: 0.9 },
        { transform: 'scale(1)', opacity: 0 },
      ],
      { duration: 460, delay, easing: EASE_OUT, fill: 'both' }
    );
  });

  const count = big ? 12 : 8;
  const inner = big ? 13 : 9;
  const outer = big ? 30 : 21;
  for (let i = 0; i < count; i += 1) {
    const angle = (i / count) * Math.PI * 2 - Math.PI / 2;
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const length = outer - inner;
    const tick = svgEl('line', {
      x1: half + cos * inner,
      y1: half + sin * inner,
      x2: half + cos * outer,
      y2: half + sin * outer,
      stroke: i % 2 && !big ? 'currentColor' : color,
      'stroke-width': 1.5,
      'stroke-linecap': 'round',
      'stroke-dasharray': `${length} ${length}`,
    });
    svg.appendChild(tick);
    tick.animate(
      [
        { strokeDashoffset: length, opacity: 1 },
        { strokeDashoffset: 0, opacity: 1, offset: 0.45 },
        { strokeDashoffset: -length, opacity: 0 },
      ],
      { duration: 420, delay: 40, easing: 'cubic-bezier(0.33, 1, 0.68, 1)', fill: 'both' }
    );
  }
}

function sheen(layer, rect, color, rtl) {
  const box = document.createElement('div');
  box.style.cssText =
    `position:absolute;left:${rect.left}px;top:${rect.top}px;width:${rect.width}px;height:${rect.height}px;overflow:hidden`;
  const band = document.createElement('div');
  band.style.cssText =
    `position:absolute;top:0;bottom:0;width:45%;left:0;` +
    `background:linear-gradient(90deg,transparent,color-mix(in srgb,${color} 14%,transparent),transparent)`;
  box.appendChild(band);
  layer.appendChild(box);
  const from = rtl ? `${rect.width}px` : '-45%';
  const to = rtl ? '-45%' : `${rect.width}px`;
  band.animate([{ transform: `translateX(${from})` }, { transform: `translateX(${to})` }], {
    duration: 560,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    fill: 'both',
  });
}

function pop(button) {
  requestAnimationFrame(() => {
    const mark = button?.firstElementChild;
    if (!mark || !mark.animate) return;
    mark.animate(
      [{ transform: 'scale(0.4)' }, { transform: 'scale(1.18)', offset: 0.55 }, { transform: 'scale(1)' }],
      { duration: 320, easing: 'cubic-bezier(0.34, 1.4, 0.64, 1)' }
    );
  });
}

export function celebrate({ button, row, color, big = false }) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!button || !document.body.animate) return;

  const layer = document.createElement('div');
  layer.setAttribute('aria-hidden', 'true');
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:70;color:var(--ink)';
  document.body.appendChild(layer);

  const rect = button.getBoundingClientRect();
  spark(layer, rect.left + rect.width / 2, rect.top + rect.height / 2, color, big);
  if (row) sheen(layer, row.getBoundingClientRect(), color, document.documentElement.dir === 'rtl');
  pop(button);

  window.setTimeout(() => layer.remove(), big ? 720 : 620);
}
